import axios from './axios-auth'

const getCategoryRoot = () =>
  new Promise((resolve, reject) => {
    axios({
      url: '/category/root',
      method: 'GET'
    })
      .then((resp) => {
        const category = {
          id: resp.data.id,
          name: resp.data.name
        }
        resolve(category)
      })
      .catch((err) => {
        reject(err)
      })
  })

const getCategoryChildren = (categoryId, cancelToken) =>
  new Promise((resolve, reject) => {
    axios({
      url: '/category/' + categoryId + '/children',
      method: 'GET',
      cancelToken: cancelToken
    })
      .then((resp) => {
        resolve(resp.data.items)
      })
      .catch((err) => {
        reject(err)
      })
  })

const getCategoryParents = (categoryId, cancelToken) =>
  new Promise((resolve, reject) => {
    axios({
      url: '/category/' + categoryId + '/parent',
      method: 'GET'
    }, {
      cancelToken: cancelToken
    })
      .then((resp) => {
        resolve(resp.data)
      })
      .catch((err) => {
        reject(err)
      })
  })

const getCategoryExclusives = (cancelToken) =>
  new Promise((resolve, reject) => {
    axios({
      url: '/category/exclusive',
      method: 'GET',
      cancelToken: cancelToken
    })
      .then((resp) => {
        resolve(resp.data.items)
      })
      .catch((err) => {
        reject(err)
      })
  })



const postCustomItemRequest = (customItem) =>
  new Promise((resolve, reject) => {
    axios({
      url: 'category/exclusive/custom-item',
      data: customItem,
      method: 'POST'
    })
      .then((resp) => {
        resolve(true)
      })
      .catch((err) => {
        reject(err)
      })
  })

export { getCategoryRoot, getCategoryChildren, getCategoryParents, getCategoryExclusives, postCustomItemRequest }
